import { TagKindSchema } from "@redotech/redo-common-model/tag";
import * as z from "zod";
import { null as zNull } from "zod";
export const deleteTag = {
  name: "deleteTag" as const,
  input: z.object({ name: z.string(), kind: TagKindSchema }),
  output: zNull(),
};
